// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"5cb6a57a","977":"8d4c3e70"}[chunkId] + ".chunk.js";
};